// extracted by mini-css-extract-plugin
export var active = "_8q-c";
export var activeIndicator = "_8q-7";
export var animate = "_8q-b";
export var contentWidthTabs = "_8q-5";
export var disabled = "_8q-d";
export var flat = "_8q-1";
export var fullWidth = "_8q-3";
export var lg = "_8q-a";
export var md = "_8q-9";
export var redoButtonTabGroup = "_8q-0";
export var sm = "_8q-8";
export var tabButton = "_8q-4";
export var tabButtonsContainer = "_8q-2";
export var xs = "_8q-6";